export default __webpack_public_path__ + "static/media/telegram_white.db0def87.svg";